import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { QuestionListResolver } from 'src/app/core/services/resolvers/question-list.resolver';
import { QuestionListComponent } from './component/questionList/questionList.component';

const routes: Routes = [
  {
    path: ':name/:parentName/:previusName',
    component: QuestionListComponent,
    data: {
      breadcrumb: (data: any) => `${data.faqsQuestionList.breadcrumb}`,
    },
    resolve: { questionList: QuestionListResolver },
  },
  {
    path: ':name/:parentName',
    component: QuestionListComponent,
    data: {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      breadcrumb: (data: any) => `${data.faqsQuestionList.breadcrumb}`,
    },
    resolve: { questionList: QuestionListResolver },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class QuestionRoutingModule {}
